import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/GroupRegister.css';
import Navbar from './Navbar';
import Footer from './Footer';
import { getCoordDetails, groupRegister } from '../Services/Api';
import { TransactionContext } from '../context/TransactionContext';

const GroupRegister = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [uploadMessage, setUploadMessage] = useState('');
  const [userData, setUserData] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [courseId, setCourseId] = useState("");
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { setTransactionId } = useContext(TransactionContext);


  const navigate = useNavigate();

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    setFile(e.target.files[0])
    if (files.length) {
      handleFiles(files);
    }
  };

  useEffect(() => {
     document.title = 'Group Register';
    const coordDetails = async () => {
      try {
        const data = await getCoordDetails();
        setUserData(data.data);
        // console.log(data.data);
      } catch (error) {
        console.error('Error fetching coordinator details:', error);
      }
    };
    coordDetails();
  }, []);

  const validateFile = (file) => {
    // Reset errors
    setFormErrors({});

    const errors = {};
    let isValid = true;

    // Check if file is selected
    if (!file) {
      errors.file = 'Please select a file';
      isValid = false;
    } else {
      // Check file extension
      const validExtensions = ['.xlsx', '.xls'];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        errors.file = 'Please select a valid Excel file (.xlsx or .xls)';
        isValid = false;
      }

      // Check file size (5MB max)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        errors.file = 'File size must be less than 5MB';
        isValid = false;
      }
    }

    // Check if program is selected
    if (!selectedProgram) {
      errors.program = 'Please select a program';
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleFiles = (files) => {
    const file = files[0];
    setSelectedFile(file);

    if (validateFile(file)) {
      setUploadStatus('success');
      setUploadMessage('File selected successfully! Ready to upload.');
      // console.log('Valid file selected:', file.name);
    } else {
      setUploadStatus('error');
    }
  };

  const handleUploadClick = () => {
    document.getElementById('certificate-file-input').click();
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (validateFile(file)) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("course_id", selectedProgram);
      formData.append("file", file);

      const submitFileFun = async () => {
        try {
          const response = await groupRegister(formData);
          // console.log(response);
          setTransactionId(response.transactionId);


          // Show success message
          setUploadStatus("success");
          setUploadMessage("File uploaded successfully!");
          setShowSuccess(true);

          // Reset form
          setSelectedProgram('');
          setSelectedFile(null);
          setFile(null);

          // Clear file input
          document.getElementById('certificate-file-input').value = '';

        } catch (err) {
          console.log(err);
          setUploadStatus("error");
          setUploadMessage("Upload failed. Please try again.");
        } finally {
          setIsLoading(false);
        }
      };

      submitFileFun();

      // console.log("Form submitted with file:", file.name);
    } else {
      setUploadStatus("error");
      setUploadMessage("Invalid file type!");
    }
  };

  const handleSuccessConfirm = () => {
    setShowSuccess(false);
    navigate('/group-list');
  };

  const handleProgramChange = (e) => {
    setSelectedProgram(e.target.value);
    setCourseId(e.target.value);
    // Clear program error when user selects a program
    if (formErrors.program) {
      setFormErrors({ ...formErrors, program: '' });
    }
  };

  const handleDownloadSample = () => {
    // Create a sample Excel file for download
    const sampleData = [
      ['Name', 'Email', 'Phone', 'Role', 'Program'],
      ['John Doe', 'john@example.com', '1234567890', 'Student', selectedProgram],
      ['Jane Smith', 'jane@example.com', '0987654321', 'Teacher', selectedProgram]
    ];

    let csvContent = "data:text/csv;charset=utf-8,";
    sampleData.forEach(row => {
      csvContent += row.join(",") + "\r\n";
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `sample_users_${selectedProgram}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Navbar />
      <div className="certificate-portal-container">
        <div className="certificate-portal-content">
          {/* Left Card */}
          <div className="certificate-portal-card">
            <div className="certificate-portal-card-header">
              <div className="certificate-portal-card-icon">
                <i className="fas fa-user-tie"></i>
              </div>
              <h2>Programme Implementation Partner</h2>
            </div>
            {userData ? (
              <div className="certificate-portal-user">
                <div className="certificate-portal-form-group">
                  <label><i className="fas fa-user"></i> User Full Name</label>
                  <div className="certificate-portal-input-with-icon">
                    <i className="certificate-portal-input-icon fas fa-user"></i>
                    <input type="text" value={userData.fullname} readOnly />
                  </div>
                </div>

                <div className="certificate-portal-form-group">
                  <label><i className="fas fa-envelope"></i> User Mail Id</label>
                  <div className="certificate-portal-input-with-icon">
                    <i className="certificate-portal-input-icon fas fa-envelope"></i>
                    <input type="email" value={userData.email} readOnly />
                  </div>
                </div>

                <div className="certificate-portal-form-group">
                  <label><i className="fas fa-phone"></i> User Phone Number</label>
                  <div className="certificate-portal-input-with-icon">
                    <i className="certificate-portal-input-icon fas fa-phone"></i>
                    <input type="text" value={userData.phone} readOnly />
                  </div>
                </div>

                <div className="certificate-portal-form-group">
                  <label><i className="fas fa-id-badge"></i> User Name</label>
                  <div className="certificate-portal-input-with-icon">
                    <i className="certificate-portal-input-icon fas fa-id-badge"></i>
                    <input type="text" value={userData.username} readOnly />
                  </div>
                </div>
              </div>
            ) : (
              <div className="certificate-portal-status-message certificate-portal-info">
                <i className="fas fa-info-circle"></i> Loading user data...
              </div>
            )}
          </div>

          {/* Right Card */}
          <div className="certificate-portal-card">
            <div className="certificate-portal-card-header">
              <div className="certificate-portal-card-icon">
                <i className="fas fa-file-upload"></i>
              </div>
              <h2>User Upload Form</h2>
            </div>

            <div className="certificate-portal-upload-info">
              <i className="fas fa-info-circle"></i>
              <p>Upload the Excel (.xlsx, .xls) file in the given format. Ensure all required fields are filled correctly.</p>
            </div>

            <form className="certificate-portal-upload-section" onSubmit={handleFormSubmit}>
              <div className="certificate-portal-form-group">
                <label><i className="fas fa-graduation-cap"></i> Select Programme</label>
                <div className="certificate-portal-custom-select">
                  <select value={selectedProgram} onChange={handleProgramChange}>
                    <option value="">Select a program</option>
                    {
                      userData.courses && userData.courses.length > 0 ? (
                        userData.courses.map((course) => (
                          <option key={course.category_id} value={course.category_id}>{course.course_name}</option>
                        ))
                      ) : (
                        <option value="">No Course Found</option>
                      )
                    }
                  </select>
                  <span className="certificate-portal-select-arrow"></span>
                </div>
                {formErrors.program && (
                  <div className="certificate-portal-field-error">
                    <i className="fas fa-exclamation-circle"></i> {formErrors.program}
                  </div>
                )}
              </div>

              <div
                className={`certificate-portal-upload-box ${isDragging ? 'certificate-portal-dragover' : ''} ${formErrors.file ? 'certificate-portal-error-border' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={handleUploadClick}
              >
                <div className="certificate-portal-upload-icon">
                  <i className="fas fa-cloud-upload-alt"></i>
                </div>
                <p className="certificate-portal-upload-text">Drag & Drop your file here</p>
                <p className="certificate-portal-upload-hint">or</p>
                <button type="button" className="certificate-portal-btn certificate-portal-btn-browse">
                  <i className="fas fa-file-excel"></i> Browse Files
                </button>
                <input
                  type="file"
                  id="certificate-file-input"
                  className="certificate-portal-file-input"
                  accept=".xlsx, .xls"
                  onChange={handleFileSelect}
                />
                <p className="certificate-portal-upload-hint">Supports .xlsx, .xls files (Max 5MB)</p>
                {selectedFile && (
                  <div className="certificate-portal-file-info">
                    <i className="fas fa-file"></i>
                    <span>{selectedFile.name}</span>
                    <span className="certificate-portal-file-size">
                      ({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)
                    </span>
                  </div>
                )}
              </div>
              {formErrors.file && (
                <div className="certificate-portal-field-error">
                  <i className="fas fa-exclamation-circle"></i> {formErrors.file}
                </div>
              )}
              <a
                href="https://ocpbackend.lsc-crm.in/Files/sample_file.xlsx"
                // href="/files/sample_file.xls"
                download="sample_file.xls"
                style={{
                  textAlign: 'center',
                  color: 'red',
                  marginTop: '-15px',
                  cursor: 'pointer',
                  display: 'block',
                  textDecoration: 'none'
                }}
              >
                <i className="fas fa-download"></i> Download Sample File
              </a>




              <button
                type="submit"
                className="certificate-portal-btn certificate-portal-btn-full"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Uploading...
                  </>
                ) : (
                  <>
                    <i className="fas fa-upload"></i> Upload File
                  </>
                )}
              </button>

              {uploadStatus === 'success' && !showSuccess && (
                <div className="certificate-portal-status-message certificate-portal-success">
                  <i className="fas fa-check-circle"></i> {uploadMessage}
                </div>
              )}

              {uploadStatus === 'error' && (
                <div className="certificate-portal-status-message certificate-portal-error">
                  <i className="fas fa-exclamation-circle"></i> {uploadMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Success Notification Overlay */}
      {showSuccess && (
        <div className="certificate-success-overlay">
          <div className="certificate-success-modal">
            <div className="certificate-success-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h3>Success!</h3>
            <p>Your data has been submitted successfully.</p>
            <button
              className="certificate-portal-btn certificate-portal-btn-full"
              onClick={handleSuccessConfirm}
              style={{ marginTop: '20px' }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default GroupRegister;